import { Collection, ProfileUserResponse, UserProfileStyle, UserResponse } from "@authory-packages/core";
import { FadeInContainer } from "../ReusableStyledComponents/FadeIn";
import { CollectionCard } from "./CollectionCard";
import { CollectionCardsWrapper, CollectionListWrapper } from "./CollectionList.styles";
import { theme } from "../../theme";
import { useWindowSize } from "../../hooks/useWindowSize";

interface PublicCollectionListProps {
    collections: Collection[];
    user?: UserResponse | ProfileUserResponse;
    profileStyle?: UserProfileStyle;
    smartShareUrl?: string;
}

/**
 * Visitor version of CollectionList. Same card grid, without the reordering and settings code.
 * @param props The collections on the profile and the owner
 * @returns The collection card grid
 */
export function PublicCollectionList({ collections, user, profileStyle, smartShareUrl }: PublicCollectionListProps) {
    const size = useWindowSize();
    const isMobile = (size.width && size.width < theme.v3.layout.sidebarLayout.mobile) || false;
    const isSidebar = profileStyle === UserProfileStyle.sidebar;

    return (
        <CollectionListWrapper>
            <FadeInContainer>
                <CollectionCardsWrapper $bpLarge={isSidebar && !isMobile ? 1400 : 1260} $bpSmall={isSidebar && !isMobile ? 1100 : 400}>
                    {collections.map((collection) => (
                        <div key={collection.canonicalSlug} style={{ background: "transparent", borderRadius: 6 }}>
                            <CollectionCard
                                collection={collection}
                                isPrivateProfilePage={false}
                                isProfilePage
                                isSorting={false}
                                authorSlug={user?.slug}
                                allowUserThemable
                                smartShareUrl={smartShareUrl}
                            />
                        </div>
                    ))}
                </CollectionCardsWrapper>
            </FadeInContainer>
        </CollectionListWrapper>
    );
}
